// extracted by mini-css-extract-plugin
module.exports = {"customize-bundle-for-dpu":"CustomizeBundleForDPU_customize-bundle-for-dpu__a_xuW"};